

export const veo = {
    tabs: {
      textToVideo: 'Text to Video',
      imageToVideo: 'Image to Video',
      referenceToVideo: 'Reference to Video'
    },
    preview: {
      emptyTitle: 'No Video Yet',
      emptyDesc: 'Enter a prompt and click generate to create your first video with keyframe control and native audio',
      hint: 'Supports Text‑to‑Video, Image‑to‑Video, and Reference‑to‑Video',
      resultLabel: 'Generated',
      download: 'Download',
      loadingNew: 'Generating video...',
      loadingRegenerate: 'Regenerating video...'
    },
    common: {
      prompt: 'Prompt',
      promptPlaceholder: "Describe your video... e.g., 'A cute cat playing with a ball of yarn in slow motion, cinematic lighting, 4K quality'",
      model: 'Model',
      fastMode: 'Fast Mode',
      qualityMode: 'Quality Mode',
      aspectRatio: 'Aspect Ratio',
      aspect169: '16:9 HD',
      aspect916: '9:16',
      aspectAuto: 'Auto',
      advancedOptions: 'Advanced Options',
      watermark: 'Watermark',
      watermarkPlaceholder: 'Add text watermark...',
      randomSeed: 'Random Seed',
      seedPlaceholder: '10000 - 99999',
      seedDesc: 'Same seed generates similar videos. Leave empty to auto‑assign.',
      autoTranslate: 'Auto‑Translate Prompt',
      autoTranslateDesc: 'Prompts will be translated to English automatically',
      creditsBar: 'Credits Cost',
      creditsValue: '{count} credits',
      generateButton: 'Generate Video ({count} credits)',
      promptRequired: 'Please enter a prompt',
      promptAndImageRequired: 'Please upload an image and enter a prompt',
      promptAndStartEndRequired: 'Please upload start & end frames and enter a prompt',
      promptAndReferenceRequired: 'Please upload reference images and enter a prompt',
      requestFailed: 'Generation request failed',
      pollingTimeout: 'Generation timed out',
      pollingFailed: 'Generation failed: {msg}'
      ,
      errorTitle: 'Generation Error'
    },
    upload: {
      clickOrDrag: 'Click or drag to upload',
      uploadTitle: 'Upload Reference Image',
      formats: 'Supported formats: JPEG, PNG, WebP • Maximum file size: 10MB',
      selectedCount: '{count}/3 images selected',
      imagesCount: '{count}/3 images'
    },
    reference: {
      info: 'Reference to Video supports Fast Mode and 16:9 aspect ratio. Upload 1–3 reference images to guide generation.'
    },
    keyframe: {
      title: 'Keyframe Mode',
      info: 'Precisely control the start and end of your AI video. Use keyframes to create smooth cinematic transitions and maintain narrative flow.',
      start: 'Start Frame',
      end: 'End Frame',
      imageFormats: 'JPG, PNG, WebP • Max 10MB'
    }
  };
